import styled from 'styled-components';

export const StyledSpan = styled.span`
  margin-top: var(--space-2);
  margin-left: var(--space-4);
`;
